// extracted by mini-css-extract-plugin
export default {"Footer":"R-QG3","copyright":"-Voy-","skeleton-progress":"q-7c1"};